module.exports = __webpack_public_path__ + "media/background-music.45f39785.webm";